// import { CloseIcon } from 'components/Material/CloseIcon'
import CloseIcon from '@mui/icons-material/Close'
import Snackbar, { SnackbarProps } from '@mui/material/Snackbar'
import IconButton from 'components/Material/IconButton'
import cn from 'classnames'
import { BodyText, LabelText } from '../Typographies'
import { Button } from 'components/Material/Button'

interface SnackbarAlertProps extends SnackbarProps {
  message: string
  statusType?: 'message' | 'success' | 'error'
  duration?: number | null
  closeFunction?: () => void
  hasCloseButton?: boolean
  customButtonName?: string
  handleCustomButton?: () => void
}

export const SnackbarAlert = ({
  message,
  statusType = 'message',
  duration = 3000,
  closeFunction,
  hasCloseButton = true,
  customButtonName,
  handleCustomButton,
  ...props
}: SnackbarAlertProps) => {
  const messageColor = () => {
    switch (statusType) {
      case 'success':
        return 'bg-green-40'
      case 'error':
        return 'bg-red-border'
      default:
        return 'bg-purple-50'
    }
  }

  return (
    <Snackbar
      {...props}
      autoHideDuration={duration}
      onClose={(_, reason) => {
        if (reason === 'clickaway') return
        if (closeFunction) closeFunction()
      }}
      sx={{
        zIndex: 9999,
        maxWidth: '639px',
        width: '100%',
        borderRadius: '8px',
        '& .MuiPaper-root': {
          backgroundColor: 'transparent',
          maxWidth: '639px',
          width: '100%',
          display: 'flex',
          borderRadius: '8px',
          flexWrap: customButtonName ? 'wrap' : 'nowrap'
        }
      }}
      action={
        customButtonName ? (
          <Button
            title={customButtonName || ''}
            onClick={() => handleCustomButton && handleCustomButton()}
          >
            <LabelText text={customButtonName} typeStyle="large" className={'text-white-bb'} />
          </Button>
        ) : (
          hasCloseButton && (
            <IconButton
              title="Fechar"
              size="small"
              aria-label="close"
              color="default"
              onClick={closeFunction}
            >
              <CloseIcon fontSize="small" sx={{ color: 'white' }} />
            </IconButton>
          )
        )
      }
      className={cn(props.className, messageColor())}
      color={messageColor()}
      message={
        customButtonName ? (
          <BodyText text={message} typeStyle="medium" className={'text-white-bb'} />
        ) : (
          <LabelText text={message} typeStyle="large" className={'text-white-bb'} />
        )
      }
    />
  )
}
